<div class="d-flex order-statuses">
  <ng-container *ngIf="showTooltips; else badges">
    <ng-container *ngFor="let status of statuses$ | async">
      <div
        class="badge-wrapper w-100"
        [atxPopover]="statusTooltipLocalize[getStatusType(status)]"
        componentClass="p-2"
        popoverPlacement="bottom"
        triggers="hover"
      >
        <ng-container
          *ngTemplateOutlet="singleBadge; context: { $implicit: status }"
        ></ng-container>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #badges>
    <ng-container *ngFor="let status of statuses$ | async">
      <div class="badge-wrapper w-100">
        <ng-container
          *ngTemplateOutlet="singleBadge; context: { $implicit: status }"
        ></ng-container>
      </div>
    </ng-container>
  </ng-template>
</div>

<ng-template #singleBadge let-status>
  <atx-badge
    [icon]="statusIcons[getStatusType(status)]"
    [ngClass]="getStatusType(status)"
    class="d-block min-w-lg-100 h-100 text-center px-2"
  >
    {{ status }}
  </atx-badge>
</ng-template>
